import { PATH_CONTENT, PATH_CONTENTS_ACTIVITY_DETAIL } from 'app/router/routesConfigContents';
import { PATH_FIXED_LAYOUT_EDITOR } from 'app/router/routesConfigFixedLayout';
import { PATH_PROGRAM, PATH_PROGRAMS, PATH_PROGRAM_DISTRIBUTION_EDITOR, PATH_PROGRAM_STEP } from 'app/router/routesConfigPrograms';

// El editor de distribución se monta por la misma razón que la ficha de contenido: es trabajo del
// Editor y su URL cuelga del programa, así que el boundary la autoriza contra él. Sin montarla, ninguna
// Route casaba y la URL caía por prefijo en la ficha del programa con un paso inexistente: pantalla en
// blanco en vez de redirección.
// Un perfil editorial invitado navega por sus programas y por los contenidos que cuelgan de ellos:
// cualquier otra ruta queda cerrada también por URL, no solo oculta en el menú. Las fichas de
// contenido se montan porque `ProgramAccessBoundary` las autoriza una por una contra
// `digital-programs/mine/contents/<guid>` y redirige a /programs cuando el contenido no es suyo.
const RESTRICTED_PATHS = new Set([
  PATH_PROGRAMS,
  PATH_PROGRAM,
  PATH_PROGRAM_STEP,
  PATH_PROGRAM_DISTRIBUTION_EDITOR,
  PATH_CONTENT,
  PATH_CONTENTS_ACTIVITY_DETAIL,
  PATH_FIXED_LAYOUT_EDITOR,
]);

export function editorialAccess(path, restrictedPrograms) {
  if (!restrictedPrograms) return true;

  return RESTRICTED_PATHS.has(path);
}
